import React from 'react'

function EditBillPassing() {
  return (
    <div>EditBillPassing</div>
  )
}

export default EditBillPassing